module.exports = __webpack_public_path__ + "static/media/1.Mini Rice Mill.3aab5221.jpg";